<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2x"><a id="page_x"></a><a id="page_xi"></a><a id="tra"></a>Note on Transliteration</h2>
<p class="noindent">T<span class="small">RANSLITERATION SYSTEMS ATTEMPT</span>, and repeatedly fail, to assimilate different written languages. Transcribing Moroccan dialectal Arabic (<em>darija</em>), standard Arabic, and French provides multiple such opportunities. In aiming for imperfect assimilation, I use two diacritical marks for darija and standard Arabic, <sup><img alt="image" class="block" src="images/lsquo.jpg"/></sup> for <sup><img alt="image" class="block" src="images/lsquo.jpg"/></sup>ayn, and <sup><img alt="image" class="block" src="images/rsquo.jpg"/></sup> for hamza. I quote different French and English versions of Arabic terms as they appear in original sources (Aïssaoua, Aïssâoua, and <sup><img alt="image" class="block" src="images/lsquo.jpg"/></sup>Isawa; Sidi Mohammed and Muhammad V). Other names of known figures and place names appear as they are commonly recognized in English (the prophet Muhammad, the city of Fez).</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// transliteration.vue?68e3bebc